import React from 'react'

import PageHeader from '../components/PageHeader'

export const InstallPage = () => {
  return (
    <main className='install-page main fit mx-auto'>
      <PageHeader extraClass='js-dark-section' title='install' />
      <div className='install-page__body flex mx-auto'>
        <div className='install-page__body__box p4 center col-12 md-col-7 mb3'>
          <div className='mb4'>
            Run the following in your terminal, then follow the onscreen
            instructions.
          </div>
          <div className='install-page__body__curl'>
            curl https://install.snips.ai -sSf | sh
          </div>
        </div>
        <div>
          Need help?{' '}
          <a
            href='https://github.com/snipsco/snips-platform-documentation/wiki/9.-Snips-Install-Script'
            target='_blank'
          >
            Ask here
          </a>
        </div>
      </div>
    </main>
  )
}

export default InstallPage



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/InstallPage.js